import { Map } from 'immutable';

// import { ADD, ADD_MULTIPLE, UPDATE, REMOVE } from './constants';
import { ADD_MULTIPLE } from './constants';

const initialState = Map();

export default (state = initialState, action) => {
  switch (action.type) {
    // case ADD:
    //   return state.set(action.skill.id, action.skill);
    case ADD_MULTIPLE:
      return state.merge(action.skills);

    // case UPDATE:
    //   return state.set(action.skill.id, action.skill);
    // case REMOVE:
    //   return state.delete(action.payload.id);
    default:
      return state;
  }
};
